import { InputNumber } from "primereact/inputnumber";
import styles from "./input-icon.module.css";

const InputIcon = ({ icon, title, ...props }) => {
  return (
    <div className={styles.wrapper} title={title}>
      <img src={icon} alt="icon" width="20" className={styles.icon} />
      <InputNumber className={styles.input} {...props} />
    </div>
  );
};

export default InputIcon;
